import React from 'react';

import PurchasingQuotaList  from 'components/Tvendo/Sale/QuotaBPartner/Colgate/PurchasingQuota/List.js';

export default function () {
  return <PurchasingQuotaList  />;
}